module.exports = __webpack_public_path__ + "img/logo_brand.0e44806f.png";